import * as React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import classnames from 'classnames';
import { Attributes } from '../types';
import Text, { TextProps } from '../Text/Text';
import './Link.css';

export interface LinkProps extends Omit<TextProps, 'textColor'> {
  /** */
  textColor?: 'blue' | 'light';
  /** */
  to?: string;
  /** */
  underline?: boolean;
}

const Link: React.ForwardRefRenderFunction<HTMLInputElement, Attributes<HTMLInputElement, LinkProps>> = (props, ref) => {
  const { textColor = 'blue', underline, ...rest } = props;
  const classes = classnames('Link', `Link--text-color-${textColor}`, {
    'Link--underline': underline,
  });

  if (props.to) {
    return (
      <Text { ...rest }
          className={ classes }
          clickable
          component={ ReactRouterLink }
          ref={ ref }
          tag="a" />
    );
  }

  return (
    <Text { ...rest }
        className={ classes }
        clickable
        ref={ ref }
        tag="a" />
  );
};

export default React.forwardRef(Link);
